import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { LanguageProvider } from "@/i18n";
import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import Benefits from "@/components/landing/Benefits";
import Process from "@/components/landing/Process";
import ContactForm from "@/components/landing/ContactForm";
import Reviews from "@/components/landing/Reviews";
import Footer from "@/components/landing/Footer";
import Privacy from "@/components/landing/Privacy";
import Terms from "@/components/landing/Terms";

function Landing() {
  return (
    <>
      <Hero />
      <Marquee />
      <Benefits />
      <Process />
      <ContactForm />
      <Reviews />
    </>
  );
}

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.14, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <LanguageProvider>
      <BrowserRouter>
        <div id="top" className="grain min-h-screen bg-[#030712] text-slate-100 antialiased">
          <Nav />
          <main>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/adatkezeles" element={<Privacy />} />
              <Route path="/aszf" element={<Terms />} />
            </Routes>
          </main>
          <Footer />
          <Toaster position="bottom-center" theme="dark" richColors />
        </div>
      </BrowserRouter>
    </LanguageProvider>
  );
}
